//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "AssociatedStores",
  props: ["value"],
  components: {},
  mounted: () => {
    if (this.value.retailer.id) {
      this.selectedRetailer = this.value.retailer;
    }

    this.loadHierarchyLists();

    this.searchFilteredStores();
  },
  data: () => ({
    separator: "horizontal",
    pagination: {
      rowsPerPage: 7 // current rows per page being displayed
    },
    storeList: [],
    retailerList: [],
    chainList: [],
    insigniaList: [],
    selectedRetailer: null,
    selectedInsignia: null,
    columns: [
      {
        name: "code",
        align: "left",
        label: "Código",
        field: "code",
        sortable: true
      },
      {
        name: "name",
        required: true,
        label: "Nome",
        align: "left",
        field: "name",
        sortable: true
      }
    ]
  }),
  methods: {
    noValidation,
    updateData() {
      this.$emit("value", this.value);
    },
    fetchRowData: function(index) {
      let data = this.data[index];
      this.$emit("clicked-row", data);
    },
    clearRetailerChildren() {
      this.selectedInsignia = null;
      this.clearInsigniaChildren();
      this.loadHierarchyLists();
      this.updateData();
    },
    clearInsigniaChildren() {
      this.value.least_store_hierarchy_level_element_id = null;
      this.clearChainChildren();
      this.loadHierarchyLists();
      this.updateData();
    },
    clearChainChildren() {
      this.value.store_ids = [];
      this.searchFilteredStores();
      this.updateData();
    },
    loadHierarchyLists() {
      BackendServices.getRetailers().then(response => {
        this.retailerList = response.data;
      });
      BackendServices.getInsigniaByRetailer(this.selectedRetailer).then(
        response => {
          this.insigniaList = response.data;
        }
      );
      BackendServices.getChainsByInsignia(this.selectedInsignia).then(
        response => {
          this.chainList = response.data;
        }
      );
    },
    searchFilteredStores(query = null) {
      let filterObject = {};

      if (this.selectedRetailerName) {
        filterObject[0] = {
          column_key: "retalhista",
          include: [this.selectedRetailerName]
        };
      }

      if (this.selectedInsigniaName) {
        filterObject[1] = {
          column_key: "insignia",
          include: [this.selectedInsigniaName]
        };
      }

      if (this.selectedChainName) {
        filterObject[2] = {
          column_key: "cadeia",
          include: [this.selectedChainName]
        };
      }

      if (query) {
        filterObject[3] = {
          column_key: "name",
          include: [query]
        };
      }

      BackendServices.getStores(
        { page: 1, rowsPerPage: 500 },
        filterObject,
        true
      ).then(response => {
        let nameData = Array.isArray(response.data) ? response.data : [];
        this.storeList = nameData.map(item => JSON.stringify(item));

        if (query) {
          filterObject[3].column_key = "code";
        }

        BackendServices.getStores(
          { page: 1, rowsPerPage: 500 },
          filterObject,
          true
        ).then(response => {
          let codeData = Array.isArray(response.data) ? response.data : [];
          this.storeList.push(codeData.map(item => JSON.stringify(item)));
          this.storeList = [...new Set(this.storeList.flat())].map(item =>
            JSON.parse(item)
          );
        });
      });
    },
    filterStores: function(name, update) {
      update(async () => {
        await this.searchFilteredStores(name);
        this.storeList = this.storeList.filter(
          item => item.name.toLowerCase().indexOf(name.toLowerCase()) >= 0
        );
      });
    }
  }
};
